import type { CityConfig } from "@/pages/city-template/types";

export const lakeGeorgeConfig: CityConfig = {
  city: "Lake George",
  state: "New York",
  stateAbbr: "NY",
  slug: "lake-george",
  route: "/cities/lake-george",
  title: "Emergency & Expedited Passport Lake George NY | Same Day Passport Lake George",
  metaDescription:
    "Emergency passport Lake George NY — same day, 24-hour, and 3-5 day expedited passport processing for the Adirondack resort region. Fast Passport Center serves Lake George, Queensbury, Bolton Landing, and all Adirondack North Country communities.",
  h1: "Emergency & Expedited Passport Services in Lake George, NY",
  heroSubtitle:
    "Lake George's fast passport solution — the Queen of American Lakes. Whether you're flying out of Albany International for a summer European trip or a winter Caribbean getaway, Fast Passport Center delivers emergency passports in as little as 24 hours and expedited processing in 3-5 days.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Scenic%20Lake%20George%20village%20in%20New%20York%20Adirondack%20Mountains%20with%20the%20Queen%20of%20American%20Lakes%20waterfront%2C%20charming%20resort%20town%20along%20the%20shoreline%20with%20boats%20and%20mountain%20backdrop%2C%20warm%20summer%20golden%20light%2C%20modern%20travel%20photography%20with%20vibrant%20blue%20lake%20water%2C%20no%20text%20overlay%2C%20picturesque%20Adirondack%20lake%20resort%20town%20scene%20with%20forested%20mountains%20in%20background&width=1600&height=700&seq=ny-lake-george-hero-001&orientation=landscape",
  heroImageAlt: "Lake George village along the waterfront with Adirondack Mountains and blue lake waters",
  geoPosition: "43.4262; -73.7123",
  geoPlacename: "Lake George, New York, United States",
  lastModified: "2026-05-31",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~210 miles (Southeast in Manhattan)",
  },
  nearbyCitiesZips: [
    { name: "Lake George", zips: "12845" },
    { name: "Queensbury", zips: "12804" },
    { name: "Glens Falls", zips: "12801" },
    { name: "Bolton Landing", zips: "12814" },
    { name: "Chestertown", zips: "12817" },
    { name: "Warrensburg", zips: "12885" },
    { name: "Diamond Point", zips: "12824" },
    { name: "Cleverdale", zips: "12820" },
    { name: "Hague", zips: "12836" },
    { name: "Ticonderoga", zips: "12883" },
    { name: "Saratoga Springs", zips: "12866, 12871" },
    { name: "Ballston Spa", zips: "12020" },
    { name: "Malta", zips: "12020" },
    { name: "Hudson Falls", zips: "12839" },
    { name: "Albany", zips: "12201-12212, 12214, 12220, 12222-12226, 12228, 12230-12232, 12233, 12234, 12235, 12236, 12237, 12238, 12239, 12240, 12241, 12242, 12243, 12244, 12245, 12246, 12247, 12248, 12249, 12250, 12252, 12255, 12256, 12257, 12260, 12261, 12262, 12288" },
    { name: "Lake Placid", zips: "12946" },
    { name: "Saranac Lake", zips: "12983" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for Lake George travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with direct access to the New York Passport Agency.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Real Human Support",
      desc: "Dedicated agents guide you through every step — no chatbots, no automated runaround. Available for Lake George residents and seasonal visitors 7 days a week.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Adirondack Resort Region",
      desc: "Lake George, Bolton Landing, Ticonderoga, and the entire Adirondack North Country — we serve the Queen of American Lakes and all surrounding communities.",
    },
  ],
  testimonials: [
    {
      name: "Jennifer M.",
      location: "Lake George, NY",
      rating: 5,
      text: "Own a seasonal resort business here and needed my passport renewed for a vendor trip to France. Fast Passport Center delivered in 4 days while I was busy with summer guests. Absolutely essential service for the Lake George business community.",
      service: "Passport Renewal",
    },
    {
      name: "Tom B.",
      location: "Bolton Landing, NY",
      rating: 5,
      text: "Emergency passport for a family cruise leaving in 5 days. Fast Passport Center got it done in 3 days. The agent even walked me through the Queensbury post office process. Saved our vacation.",
      service: "Emergency Passport",
    },
    {
      name: "Sarah L.",
      location: "Queensbury, NY",
      rating: 5,
      text: "First-time passport for my daughter's study abroad. We applied through the Lake George post office and Fast Passport Center handled the expedited processing. Passport arrived in 5 days exactly as promised.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "lake-george-1",
      name: "Lake George Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "1 Post Office Street",
      city: "Lake George",
      state: "NY",
      zip: "12845",
      phone: "518-668-3341",
      hours: "Mon-Fri 9:00 AM - 4:30 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Downtown Lake George",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Main Lake George passport acceptance facility. First-time applicants and those not eligible for mail-in renewal must apply in person. Convenient for seasonal residents and visitors.",
      icon: "ri-building-2-line",
    },
    {
      id: "lake-george-2",
      name: "Queensbury Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "553 Aviation Road",
      city: "Queensbury",
      state: "NY",
      zip: "12804",
      phone: "518-793-6198",
      hours: "Mon-Fri 9:00 AM - 4:30 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Queensbury (~8 miles south)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available by appointment. Convenient for Queensbury and North Country residents near Lake George.",
      icon: "ri-building-2-line",
    },
    {
      id: "lake-george-3",
      name: "Glens Falls Main Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "16 Hudson Avenue",
      city: "Glens Falls",
      state: "NY",
      zip: "12801",
      phone: "518-793-2634",
      hours: "Mon-Fri 8:30 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Glens Falls (~10 miles south)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Glens Falls passport acceptance facility. Additional option for Lake George and Warren County residents needing in-person services.",
      icon: "ri-building-2-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Lake George?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for Lake George residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 3-5 day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in Lake George?",
      a: "The Lake George Post Office at 1 Post Office Street is the main Lake George passport acceptance facility. The Queensbury Post Office at 553 Aviation Road and Glens Falls Main Post Office at 16 Hudson Avenue are also convenient options for Warren County and Adirondack region residents.",
    },
    {
      q: "Can I get same-day passport photos in Lake George?",
      a: "Yes — passport photos are available at CVS Pharmacy, Walgreens, and Rite Aid locations in Lake George, Queensbury, and Glens Falls. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements.",
    },
    {
      q: "How much does an expedited passport cost in Lake George?",
      a: "Government fees are set by the State Department and vary based on passport type (book vs card, large book option). Fast Passport Center's service fees depend on processing speed: 10-day Smart Saver, 3-5 day Expedited, or 24-hour Emergency. Call 877-253-0084 for a personalized quote based on your Lake George passport needs.",
    },
    {
      q: "Do I need to visit the New York Passport Agency in person?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency in Manhattan. As a registered courier, we handle the agency submission for you. The only reason to visit the agency directly is for a documented life-or-death emergency, and appointments are extremely difficult to obtain.",
    },
    {
      q: "What is the fastest way to renew a passport in Lake George?",
      a: "The fastest way to renew a passport in Lake George is through Fast Passport Center's 3-5 day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit. For even faster renewal, our 24-hour emergency service is available.",
    },
    {
      q: "Can I get a child passport expedited in Lake George?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in Lake George and all Warren County communities. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "Does Fast Passport Center have an office in Lake George?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in Lake George. We serve the Adirondack resort region and all of Warren County through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Lake George", address: "various CVS locations in Lake George, Queensbury, and Glens Falls", hours: "Mon-Sun, hours vary by location" },
    { name: "Walgreens — Glens Falls", address: "various Walgreens locations in Glens Falls and Queensbury", hours: "Mon-Sun, hours vary by location" },
    { name: "Rite Aid — Lake George", address: "Rite Aid locations in Lake George and Glens Falls", hours: "Mon-Sun, hours vary by location" },
    { name: "Walmart Photo Center — Queensbury", address: "Walmart Supercenter, Queensbury", hours: "Mon-Sun 8:00 AM - 10:00 PM" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Queensbury",
      address: "579 Aviation Road, Queensbury, NY 12804",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Queensbury DMV office for license renewals and REAL ID applications. Serves Lake George, Queensbury, and Glens Falls area.",
      featured: true,
    },
    {
      name: "NYS DMV — Hudson Falls",
      address: "3839 Burgoyne Avenue, Hudson Falls, NY 12839",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Hudson Falls DMV office serving eastern Warren County and northern Washington County residents.",
      featured: false,
    },
    {
      name: "NYS DMV — Saratoga Springs",
      address: "6 Franklin Square, Saratoga Springs, NY 12866",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Saratoga Springs DMV office serving southern Warren County and northern Saratoga County.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ALB",
      name: "Albany International Airport",
      distance: "~55 miles from Lake George",
      address: "737 Albany Shaker Road, Albany, NY 12211",
      note: "The closest major airport to Lake George with flights to destinations nationwide and international connections. Most convenient for Adirondack travelers.",
      flightUrl: "https://www.albanyairport.com/",
      flightLabel: "Albany Airport",
      featured: true,
    },
    {
      code: "KGFL",
      name: "Saratoga County Airport",
      distance: "~25 miles from Lake George",
      address: "21 West Milton Road, Ballston Spa, NY 12020",
      note: "General aviation airport serving Saratoga County and the Capital Region. For private and charter flights.",
      flightUrl: "https://www.saratogacountyairport.com/",
      flightLabel: "Saratoga Airport",
      featured: false,
    },
    {
      code: "5B2",
      name: "Floyd Bennett Memorial Airport (Glens Falls)",
      distance: "~10 miles from Lake George",
      address: "443 Queensbury Avenue, Queensbury, NY 12804",
      note: "General aviation airport serving Glens Falls and the Adirondack region. For private and charter flights.",
      flightUrl: "https://www.glensfallsairport.com/",
      flightLabel: "Glens Falls Airport",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-passport-line",
      title: "Emergency Passport",
      description: "For Lake George travelers with urgent departures within 24 hours to 2 weeks. Direct New York Passport Agency submission with dedicated courier handling.",
      bullets: ["Processing as fast as 24 hours", "Dedicated agent assigned to your case", "Daily status updates"],
      badge: "Fastest",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Fast renewal for Lake George residents with a valid passport issued within the last 15 years at age 16 or older.",
      bullets: ["3-5 day or 10-day options available", "No acceptance clerk visit required", "Secure overnight document return"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Lake George residents with step-by-step guidance through the acceptance clerk process.",
      bullets: ["Complete application review before submission", "Acceptance clerk appointment guidance", "3-5 day or 10-day processing options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement service for Lake George residents who have lost their passport or had it stolen.",
      bullets: ["DS-64 form guidance included", "Replacement in 3-5 days or 10 days", "Acceptance clerk visit required"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 in Lake George, with parental consent guidance and acceptance clerk support.",
      bullets: ["Parental consent documentation review", "Both parents present or notarized consent", "3-5 day or 10-day processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal name change for Lake George residents.",
      bullets: ["Marriage certificate or court order review", "Name change in 3-5 days or 10 days", "No clerk visit for most renewals"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Lake George travelers with immediate departure needs from Albany International or Glens Falls Airport." },
    { name: "Passport Renewal", description: "Fast passport renewal for Lake George residents with a recent valid passport." },
    { name: "New Passport", description: "First-time passport application assistance for Lake George residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement for Lake George residents who have lost their passport." },
    { name: "Child Passport", description: "Passport services for minors under 16 in Lake George and Warren County." },
    { name: "Name Change", description: "Passport name change service after marriage, divorce, or legal name change in Lake George." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photos must be 2\"x2\" with a plain white or off-white background. Many Lake George travelers get rejected at the acceptance clerk because their photos don't meet strict State Department specs.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Missing or Incorrect Forms",
      description: "Using the wrong form (DS-11 vs DS-82) or missing required fields can cause weeks of delays. We review every form before submission.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8-11 weeks. Many Lake George travelers wait until the last minute, leaving no buffer for problems.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Payment Amount",
      description: "Government fees change frequently. Using an outdated check or wrong amount will cause your application to be returned.",
    },
    {
      icon: "ri-shield-line",
      title: "Damaged or Expired ID",
      description: "Your driver's license or state ID must be valid and unexpired. Many applicants don't realize their ID is about to expire until it's too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For child passports, both parents must appear or provide notarized consent. Missing documentation is the #1 reason child applications are delayed.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-file-list-3-line",
      title: "Complete Your Application",
      description: "Fill out your passport application online or over the phone with our Lake George team. We review everything for accuracy.",
    },
    {
      number: "02",
      icon: "ri-upload-cloud-line",
      title: "Send Us Your Documents",
      description: "Ship your documents via overnight courier to our secure processing center. We confirm receipt and begin review immediately.",
    },
    {
      number: "03",
      icon: "ri-search-line",
      title: "We Review Everything",
      description: "Our agents verify your forms, photos, and supporting documents meet all State Department requirements — no surprises.",
    },
    {
      number: "04",
      icon: "ri-shield-check-line",
      title: "Courier Submission",
      description: "As a registered U.S. Department of State courier, we submit your application directly to the New York Passport Agency.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Receive Your Passport",
      description: "Your passport is delivered securely to your Lake George address. We provide tracking and daily status updates throughout.",
    },
  ],
  processingOptions: [
    {
      speed: "8-11",
      unit: "weeks",
      label: "Standard Processing",
      tag: "Post Office",
      tagColor: "bg-gray-200 text-gray-600",
      features: [
        "Mail-in application",
        "No expedited handling",
        "No dedicated agent",
        "No phone or email contact for your case",
        "Updates only by physical mail letter",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "10",
      unit: "business days",
      label: "Smart Saver",
      tag: "Fast Passport Center",
      tagColor: "bg-green-100 text-green-700",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "3-5",
      unit: "business days",
      label: "Expedited Processing",
      tag: "Recommended",
      tagColor: "bg-[#1A365D] text-white",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "24",
      unit: "hours",
      label: "Emergency Processing",
      tag: "Life or Death",
      tagColor: "bg-red-100 text-red-600",
      features: [
        "For documented life-or-death emergencies only",
        "Requires proof of emergency travel",
        "Strictly for documented life-or-death emergencies",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Must book weeks in advance", fpc: "No appointment needed — we handle agency access" },
    { feature: "Processing Speed", agency: "1-2 business days (if you get an appointment)", fpc: "As fast as 3-5 days or 24 hours for emergencies" },
    { feature: "Document Review", agency: "No pre-check — one mistake means restart", fpc: "Complete review before submission — we catch errors" },
    { feature: "Travel Proof", agency: "Requires printed itinerary with confirmed travel within 2 weeks", fpc: "Flexible documentation requirements" },
    { feature: "Updates", agency: "No phone or email support — only mail updates", fpc: "Daily status updates via phone and email" },
    { feature: "Guarantee", agency: "No guarantee of appointment or same-day processing", fpc: "Reserved agency slots with predictable processing" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "New York City", route: "/cities/new-york-city" },
    { name: "Brooklyn", route: "/cities/brooklyn" },
    { name: "Queens", route: "/cities/queens" },
    { name: "Buffalo", route: "/cities/buffalo" },
    { name: "Albany", route: "/cities/albany-ny" },
    { name: "Rochester", route: "/cities/rochester" },
    { name: "Syracuse", route: "/cities/syracuse" },
    { name: "Yonkers", route: "/cities/yonkers" },
    { name: "Utica", route: "/cities/utica" },
    { name: "Schenectady", route: "/cities/schenectady" },
    { name: "Troy", route: "/cities/troy" },
    { name: "Saratoga Springs", route: "/cities/saratoga-springs" },
    { name: "Elmira", route: "/cities/elmira" },
    { name: "Ithaca", route: "/cities/ithaca" },
    { name: "Corning", route: "/cities/corning" },
    { name: "Jamestown", route: "/cities/jamestown" },
    { name: "Plattsburgh", route: "/cities/plattsburgh" },
    { name: "Watertown", route: "/cities/watertown" },
    { name: "Ogdensburg", route: "/cities/ogdensburg" },
    { name: "Glens Falls", route: "/cities/glens-falls" },
    { name: "Malone", route: "/cities/malone" },
    { name: "Tupper Lake", route: "/cities/tupper-lake" },
    { name: "Kingston", route: "/cities/kingston" },
    { name: "Middletown", route: "/cities/middletown-ny" },
    { name: "New Paltz", route: "/cities/new-paltz" },
    { name: "Poughkeepsie", route: "/cities/poughkeepsie" },
    { name: "Newburgh", route: "/cities/newburgh" },
    { name: "Beacon", route: "/cities/beacon" },
    { name: "Fishkill", route: "/cities/fishkill" },
    { name: "Mount Vernon", route: "/cities/mount-vernon" },
    { name: "Tarrytown", route: "/cities/tarrytown" },
    { name: "Hyde Park", route: "/cities/hyde-park" },
    { name: "Red Hook", route: "/cities/red-hook" },
    { name: "Rhinebeck", route: "/cities/rhinebeck" },
    { name: "Hudson", route: "/cities/hudson-ny" },
    { name: "Catskill", route: "/cities/catskill" },
    { name: "New York State", route: "/states/new-york" },
  ],
  fpcOfficeNote:
    "Fast Passport Center serves Lake George and the Adirondack resort region as a remote courier service. We do not have a physical office in Lake George, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeDistance: "Remote courier service — Lake George area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to Lake George and all of the Adirondack North Country. From Bolton Landing to Ticonderoga, from the Queen of American Lakes to the High Peaks — we serve the entire Adirondack gateway region with the same fast, reliable processing.",
  nearbyCitiesIntro:
    "We proudly serve Lake George and all surrounding communities across Warren County and the Adirondack region. Whether you're in Queensbury, Bolton Landing, or Ticonderoga, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our Lake George customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing.",
  mistakesIntro:
    "These are the most common mistakes Lake George travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "Lake George travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in Lake George. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
};

export default lakeGeorgeConfig;